import { render, staticRenderFns } from "./StudentIdForm.vue?vue&type=template&id=3bbb75a0&scoped=true"
import script from "./StudentIdForm.vue?vue&type=script&lang=js"
export * from "./StudentIdForm.vue?vue&type=script&lang=js"
import style0 from "./StudentIdForm.vue?vue&type=style&index=0&id=3bbb75a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb75a0",
  null
  
)

export default component.exports